<template>
  <div class="lg:flex">
    <div class="lg:w-1/2 w-auto">
      <div class="lg:flex">
        <!-- Shipping Address -->
        <form class="w-full text-center p-4">
          <h1 class="text-gray-800 border-b text-xl">Lieferaddresse</h1>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2 pt-6">
              Straße und Hausnummer 
              <span class="font-normal">
                (Pflichtfeld)
              </span>
            </label>
            <input
              class="shadow lg:w-1/2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              :class="{'border-red-600' : $v.address_1.$error}"
              type="text"
              v-model.trim="$v.address_1.$model"
              @input="$v.address_1.$touch()"
            />
            <span
              class="block text-red-600 font-semibold text-sm"
              v-if="$v.address_1.$error && !$v.address_1.required"
            >Dies ist ein Pflichtfeld.</span>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Adresszusatz / Firma / c/o 
              <span class="font-normal">
                (Pflichtfeld)
              </span>
            </label>
            <input
              class="shadow lg:w-1/2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              :class="{'border-red-600' : $v.address_2.$error}"
              type="text"
              v-model.trim="address_2"
            />
            <span
              class="block text-red-600 font-semibold text-sm"
              v-if="$v.address_2.$error && !$v.address_2.required"
            >Dies ist ein Pflichtfeld.</span>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Stadt 
              <span class="font-normal">
                (Pflichtfeld)
              </span>
            </label>
            <input
              class="shadow lg:w-1/2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              :class="{'border-red-600' : $v.city.$error}"
              type="text"
              v-model.trim="city"
            />
            <span
              class="block text-red-600 font-semibold text-sm"
              v-if="$v.city.$error && !$v.city.required"
            >Dies ist ein Pflichtfeld.</span>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Postleitzahl 
              <span class="font-normal">
                (Pflichtfeld)
              </span>
            </label>
            <input
              type="text"
              class="shadow lg:w-1/2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              :class="{'border-red-600' : $v.zip.$error}"
              v-model.trim="zip"
            />
            <span
              class="block text-red-600 font-semibold text-sm"
              v-if="$v.zip.$error && !$v.zip.required"
            >Dies ist ein Pflichtfeld.</span>
            <div
              class="text-red-600 font-semibold text-sm"
              v-if="!$v.zip.numeric"
            >Dies ist ein Pflichtfeld.</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2">
              Land 
              <span class="font-normal">
                (Pflichtfeld)
              </span>
            </label>
            <input
              class="shadow lg:w-1/2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              :class="{'border-red-600' : $v.country.$error}"
              type="text"
              v-model.trim="country"
            />
            <span
              class="block text-red-600 font-semibold text-sm"
              v-if="$v.country.$error && !$v.country.required"
            >Dies ist ein Pflichtfeld.</span>
          </div>
        </form>
        <!-- /Shipping Address -->
      </div>
    </div>
    <OrderReview :cartItems="cartItems" :finalModel="finalModel"/>
  </div>
</template>

<script>
import OrderReview from './OrderReview';
import axios from "axios";
import {
  required,
  minLength,
  numeric,
  maxLength
} from "vuelidate/lib/validators";

export default {
  components: {
    OrderReview
  },
  props: {
    cartItems: Array,
    finalModel: Object
  },
  data() {
    return {
      step: 1,
      type: "",
      address_1: "",
      address_2: "",
      city: "",
      zip: "",
      country: "",
      checked: true,
      isEmpty: false
    };
  },
  validations: {
    address_1: {
      required
    },
    address_2: {
      required
    },
    city: {
      required
    },
    zip: {
      numeric,
      required,
      minLength: minLength(4),
      maxLength: maxLength(6)
    },
    country: {
      required
    },
    form: [
      "address_1",
      "address_2",
      "city",
      "zip",
      "country",
    ]
  },
  created() {
    this.getAddress();
  },
  methods: {
    getAddress() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      // this.isEmpty = true;

      axios
        .get(`${process.env.VUE_APP_API}/user`)
        .then(response => {
          this.addresses = response.data.data.address;
          this.addresses.forEach(element => {
            if (element.isDefault === 1) {
              this.defaultAddress = element;

              if (element.type === "Shipping") {
                this.isEmpty = true;
                this.type = element.type;
                this.address_1 = element.address_1;
                this.address_2 = element.address_2;
                this.delivery_date = element.delivery_date;
                this.city = element.city;
                this.zip = element.zip;
                this.country = element.country;
              }
              this.isEmpty = false;
            }
          });
        })
        .catch(error => console.log(error));
    },
    
    validate() {
      this.$v.form.$touch();
      var isValid;
      if(this.isEmpty) {
         isValid = this.$v.form.$invalid;
      } else {
         isValid = !this.$v.form.$invalid;
      }
      this.$emit("on-validate", this.$data, isValid);

      return isValid;
      
    },
  }
};
</script>

<style>
</style>